export default {
  title: {
    en: 'Secure credit card payment',
  },
  text: {
    en: 'All data is encrypted. Your card number is never stored on Scentbird servers.',
  },
}
